import React, { useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import styleClasses from '../../../containers/try2/try2.module.scss';
import { ISingleItemOtherDressing } from '../../../models/order';
import OtherDressingChild from './OtherDressingChild';
import { PULSE_VIEW_ID, trackPulseView } from '../../../analytics/pulseViewIds';

const SingleItemOtherDreesing: React.FC<ISingleItemOtherDressing> = (props) => {
  const {
    modalShow,
    closeModal,
    otherDressingData,
    requiredModifierGroup,
    noDressingHandler,
    removeSelectedIngredients,
    selectedIngredients,
    selectedAddedIngredients,
    updateSelectedModifiers,
    noDressing,
    selectedOtherDressingData,
    addSelectedIngredients,
    enableOtherRequiredByDefaultSelectionAndSizeClickAction,
    label,
    price,
  } = props;

  useEffect(() => {
    if (modalShow) {
      trackPulseView(PULSE_VIEW_ID.OTHER_CUSTOMIZATION_MODAL, {
        page_path: window.location.pathname,
      });
    }
  }, [modalShow]);

  return (
    <Modal
      show={modalShow}
      onHide={closeModal}
      centered
      className={`${
        otherDressingData && 'other-dressings-modal'
      } theme-modal-style app_container_wrap no-padding border-radius-15 border-radius-sm-12 upperside-radius-sm-only try2_dressing_modal`}
    >
      <Modal.Header className="pt-0" id="close_button2">
        <button
          type="button"
          className="btn modal-close-button pe-0 sm-blue-icon"
          onClick={closeModal}
        >
          Close
        </button>
      </Modal.Header>
      <Modal.Body
        className={`${
          otherDressingData && 'pe-3 pe-md-0'
        } app_container_wrap px-0 text-center`}
      >
        <div
          className={`${styleClasses.items_wrap} ${
            !otherDressingData && 'mb-5 mb-md-4 mb-sm-5'
          } ${styleClasses.select_dressing_wrapper}`}
        >
          <OtherDressingChild
            requiredModifierGroup={requiredModifierGroup}
            noDressingHandler={noDressingHandler}
            setOtherDressingData={removeSelectedIngredients}
            selectedIngredients={selectedIngredients}
            selectedAddedIngredients={selectedAddedIngredients}
            handleIngredientSelection={(data) => updateSelectedModifiers(data)}
            sectionSelected={'1'}
            isNoDressing={noDressing}
            showRecommendedButton={false}
            addSelectedIngredients={addSelectedIngredients}
            label={label}
            enableOtherRequiredByDefaultSelectionAndSizeClickAction={enableOtherRequiredByDefaultSelectionAndSizeClickAction}
            price={price}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default SingleItemOtherDreesing;
